<unit>{{'đ/¥' | lang}}</unit>
